import axiosInstance from './axiosConfig';
import { ImageStyle, ImageStyleCategoryUser, ImageStylesResponse, PlatformType } from './imageGenerationService';

// Raw API response types (from backend)
interface RawMaterialStyle {
  id: number;
  name: string;
  prompt_template: string;
  reference_image_url?: string;
  thumbnail_url?: string;
  description: string;
  sort_order: number;
  platforms?: PlatformType[];
}

interface GroupedMaterialStyles {
  category: string;
  styles: RawMaterialStyle[];
}

interface RawMaterialStylesResponse {
  success: boolean;
  data: {
    categories: string[];
    grouped_styles: GroupedMaterialStyles[];
    total_count: number;
  };
}

interface MaterialStyleCategoriesResponse {
  success: boolean;
  data: ImageStyleCategoryUser[];
}

const materialStyleService = {
  /**
   * Get all active material styles
   * Returns the same ImageStylesResponse format as imageGenerationService.getStyles()
   */
  async getStyles(): Promise<ImageStylesResponse> {
    const response = await axiosInstance.get<RawMaterialStylesResponse>('/material-styles');

    const flatStyles: ImageStyle[] = [];

    if (response.data.success && response.data.data?.grouped_styles) {
      for (const group of response.data.data.grouped_styles) {
        for (const style of group.styles) {
          flatStyles.push({
            id: style.id,
            name: style.name,
            description: style.description || '',
            category: group.category,
            platforms: style.platforms || [],
            aspect_ratio: '1:1',
            style_prompt: style.prompt_template || '',
            example_image_url: style.reference_image_url || style.thumbnail_url,
            is_active: true,
            is_favorited: false,
            created_at: '',
            updated_at: '',
          });
        }
      }
    }

    return {
      success: response.data.success,
      data: flatStyles,
    };
  },

  /**
   * Get all active material style categories
   */
  async getStyleCategories(): Promise<ImageStyleCategoryUser[]> {
    const response = await axiosInstance.get<MaterialStyleCategoriesResponse>('/material-styles/categories');
    return response.data.data || [];
  },
};

export default materialStyleService;
